import React, { useState } from 'react';
import { Button, Steps } from 'antd';
import { useTranslation } from 'react-i18next';

const { Step } = Steps;

const StepPanel = ({ steps, nextStep, prevStep, activeStep, isSubmitting }) => {
  const { t } = useTranslation();

  const next = async () => {
    await nextStep();
  };

  return (
    <>
      <Steps
        current={activeStep}
        style={{ width: '100%', marginBottom: '20px' }}
      >
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>

      {steps.map((item, index) => (
        <div
          className={`steps-content ${
            item.step !== activeStep + 1 && 'hidden'
          }`}
          key={item.step}
        >
          {item.content}
        </div>
      ))}
      <div className="steps-action">
        {activeStep < steps.length - 1 && (
          <Button type="primary" onClick={next}>
            {t('form.vehicleForm.steps.next')}
          </Button>
        )}
        {activeStep === steps.length - 1 && (
          <Button
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            {t('form.vehicleForm.steps.submit')}
          </Button>
        )}
        {activeStep > 0 && (
          <Button style={{ margin: '0 8px' }} onClick={prevStep}>
            {t('form.vehicleForm.steps.previous')}
          </Button>
        )}
      </div>
    </>
  );
};

export { StepPanel };
